import api from "../../Http/global-vars";
import { FETCH_ADMINS } from "../types";
import axios from "axios";

export const fetchAdmins = () => {
  return async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("userToken")}`,
      },
    };
    const url = api + "sousadmin/";
    await axios
      .get(url, config)
      .then(async (res) => {
        // const data = await res.json();
        // console.log("data projects", res);
        dispatch({
          type: FETCH_ADMINS,
          payload: res?.data.results.sort((a, b) => b?.id - a?.id),
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};
